export default () => {
  try {
    return Boolean(window && window.document);
  } catch (err) {
    return false;
  }
};
